import { createSlice } from '@reduxjs/toolkit';
import { getDetailQuiz } from './quizThunk';
import { IQuizDetail } from '~/utils/interface/quiz';

interface QuizState {
  quizDetail?: IQuizDetail;
  isLoading: boolean;
  errorMessage?: string;
}

const initialState: QuizState = {
  isLoading: false,
};

const quizSlice = createSlice({
  name: 'quizSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Detail Quiz
    builder
      .addCase(getDetailQuiz.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = undefined;
      })
      .addCase(getDetailQuiz.fulfilled, (state, action) => {
        state.quizDetail = action.payload.data;
        state.isLoading = false;
        state.errorMessage = undefined;
      })
      .addCase(getDetailQuiz.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
      });
  },
});

// Actions
export const quizAction = quizSlice.actions;

// Reducer
const quizReducer = quizSlice.reducer;
export default quizReducer;
